<script setup>
import router from '@/router';
import InputField from '@/components/InputField.vue';

import { useStore } from 'vuex';
import {
  ref,
  computed,
  watch,
  TransitionGroup,
  nextTick,
  onMounted,
  onUnmounted,
} from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
defineOptions({
  name: 'TherapyRoom',
});

const store = useStore();
let isLoading = ref(false);
const input = ref('');
const inputField = ref(null);

const notTypingTimout = ref(null);

const onInputUpdate = async (val) => {
  input.value = val;
};

const therapistName = computed(() => store.getters.therapistName);
const reset = ref(false);

const sendMessage = async () => {
  const contentInput = input.value;
  if (contentInput == '') {
    return;
  }
  //sanitize input server
  // eerste de usermessage

  store.commit('addTherapyMessage', {
    role: 'user',
    content: contentInput,
  });

  reset.value = !reset.value;
  isLoading.value = true;
  try {
    const result = await store.dispatch('post', {
      end_point: 'getTherapyCompletion',
      body_vars: {
        role: 'user',
        content: contentInput,
      },
    });

    //beetje lomp maar het kan zijn dat de therapy voorbij is en dna is er geen result
    if (!result.data) {
      isLoading.value = false;
      return;
    }

    const { role, content } = result.data;

    //choices":[{"message":{"role":"assistant","content":"HTML is a markup language used for creating web pages, while XML is a markup language used for storing and transporting data. \n\nHTML is designed to display information on a web page, while XML is designed to store and transport data between different systems. HTML has a predefined set of tags that define the structure and content of a web page, while XML allows the user to define their own tags and structure to suit their specific needs.\n\nHTML is more forgiving than XML when it comes to syntax errors, as it is designed to be easily parsed by web browsers. XML, on the other hand, requires strict adherence to syntax rules to be parsed correctly.\n\nIn summary, HTML is used for displaying information, while XML is used for storing and transporting data between different systems."},"finish_reason":"stop","index":0}]}

    /*str.match(/.*?(?=<\/a>|$)/i)[0]
        This means: match zero-or-more character lazily, until reaching a </a> or end of string.

        Note that *? is a single operator, (.*)? is not the same as .*?.

        */

    if (!content || !role) {
      isLoading.value = false;
      return;
    }

    if (role == 'engine' && content == 'tooSoon') {
      store.commit('removeTherapyMessage');
      isLoading.value = false;
      return;
    }
    // dan de assistant message
    store.commit('addTherapyMessage', {
      role,
      content,
    });
    // Focus the input field after receiving a message
    nextTick(() => {
      if (inputField.value) {
        inputField.value.focus();
        inputField.value.$el.scrollIntoView({ behavior: 'smooth' });
      }
    });
  } catch (error) {
    store.dispatch('modal/setModal', {
      title: 'Completion error',
      text: error.message,
      type: 'notification',
    });
  }

  isLoading.value = false;
};

const htmlResponse = (content) => {
  if (content == null) return '';
  return content
    .replace(/(\\n\\n\d+).*?(?=\\n|$)/g, '<li>')
    .replace(/\\n/g, '<br>');
};

const endTherapy = computed(() => {
  return store.getters.endTherapy;
});

const getTimeRemaining = computed(() => {
  if (endTherapy.value) {
    return {
      seconds: 0,
      minutes: 0,
    };
  }
  const total = store.getters.secondsLeft;
  return {
    seconds: Math.floor(total % 60),
    minutes: Math.floor((total / 60) % 60),
  };
});

const closeTherapy = async () => {
  await store.dispatch('closeTherapy'); //vernietig de therapie zelf.
  router.push({ name: `Home` });
};

const therapyMessages = computed(() => {
  return store.getters.therapyMessages;
});

const lastMessageByKrenk = computed(() => {
  return store.getters.lastMessageByKrenk;
});

const therapistImage = computed(() => {
  return store.getters.therapistImage;
});

const notTyping = () => {
  console.log('not typing');
  store.commit('isNotTyping');
};

const keydown = (event) => {
  if (notTypingTimout.value) {
    clearTimeout(notTypingTimout.value);
  }
  // na 5 seconden niet typen wordt de isTyping status op false gezet
  notTypingTimout.value = setTimeout(() => {
    notTyping();
  }, 5000);
  if (event.key == 'Enter') {
    event.preventDefault();
    event.stopPropagation();
    sendMessage();
  } else {
    store.commit('isTyping');
  }
};

onMounted(() => {
  //initiele waarde van de timout op 10 seconden
  notTypingTimout.value = setTimeout(() => {
    notTyping();
  }, 10000);
});

onUnmounted(() => {
  if (notTypingTimout.value) {
    clearTimeout(notTypingTimout.value);
  }
});
watch(
  () => therapyMessages.value,
  (newValue) => {
    if (newValue) {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  }
);

onBeforeRouteLeave((to, from, next) => {
  store.commit('leaveAllRooms');
  next();
});
</script>
<template>
  <div class="therapy is-size-6-mobile is-size-5-tablet">
    <h1 class="maintitle title is-size-3-mobile is-size-2-tablet">
      KRENK THERAPIE
    </h1>
    <p class="time is-size-7-mobile is-size-5-tablet">
      {{ String(getTimeRemaining.minutes).padStart(2, '0') }}m:
      {{ String(getTimeRemaining.seconds).padStart(2, '0') }}s
    </p>
    <div class="discussionheader">
      <div class="content">
        <div class="field">
          <div class="control">
            <button
              class="button is-danger is-size-6-mobile is-size-5-tablet"
              @click="closeTherapy"
            >
              sluit therapie
            </button>
          </div>
        </div>
      </div>
    </div>

    <TransitionGroup
      name="messagelist"
      class="content"
      tag="div"
      v-if="therapyMessages && therapyMessages.length != 0"
    >
      <div
        v-for="(message, index) in therapyMessages"
        :key="index"
        class="messagewrap"
        :class="[message.role]"
      >
        <p class="role" v-if="message.role != 'engine'">
          {{ message.role == 'user' ? 'jij' : therapistName }}
        </p>
        <p class="message" v-html="htmlResponse(message.content)"></p>
      </div>
    </TransitionGroup>

    <div class="content">
      <input-field
        ref="inputField"
        :label="lastMessageByKrenk"
        :is-input="false"
        :default-value="''"
        :reset="reset"
        :placeholder="'praat met je coach'"
        :read-only="false"
        :maxlength="256"
        :disabled="isLoading || endTherapy"
        @inputupdate="onInputUpdate"
        @keydown="keydown"
      ></input-field>

      <div class="field discussioninput">
        <div class="control">
          <button
            class="button is-success is-size-6-mobile is-size-5-tablet"
            :disabled="isLoading || endTherapy"
            :class="isLoading ? 'is-loading' : ''"
            @click="sendMessage"
          >
            <span>verstuur</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.messagelist-enter-active,
.messagelist-leave-active {
  transition: all 0.5s ease;
}
.messagelist-enter-from,
.messagelist-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
